<template>
  <textarea
    class="form-control"
    :class="{
      'is-invalid': hasError
    }"
    :rows="rows"
    :value="$attrs.value"
    v-bind="{
      maxlength: maxLength
    }"
    @input="onInput"
  />
</template>
<script>
export default {
  name: 'FormTextarea',
  props: {
    rows: {
      type: Number,
      default: 3
    },
    maxLength: {
      type: Number,
      default: null
    },
    hasError: Boolean
  },
  methods: {
    onInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
